import { forwardRef, useRef, useImperativeHandle, useEffect } from "react";

interface HomeInputProps {
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const HomeInput = forwardRef<HTMLInputElement, HomeInputProps>(
  ({ onKeyDown }, ref) => {
    const internalRef = useRef<HTMLInputElement>(null);

    useImperativeHandle(ref, () => internalRef.current!);

    useEffect(() => {
      internalRef.current?.focus();
    }, []);

    const handleBlur = () => {
      if (window?.top !== window?.self) {
        // don't refocus if in an iframe
        return;
      }

      setTimeout(() => internalRef.current?.focus(), 0);
    };

    return (
      <input
        ref={internalRef}
        type="text"
        inputMode="none"
        readOnly
        onKeyDown={onKeyDown}
        onBlur={handleBlur}
        autoComplete="off"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: 0,
          height: 0,
          opacity: 0,
          pointerEvents: "none",
        }}
      />
    );
  },
);
